<div>

    <app-benefits-button/>

    <app-benefits-container/>

</div>